export default __webpack_public_path__ + "static/door-image-7cbaec28696012d669e519db8a9f85be.png";